module["exports"] = [
  "Österreich"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/de_AT/address/default_country.js
// module id = 376
// module chunks = 0